<!-- 残り回数表示 -->
<template>
  <div>
    <div class="label">
      <div>使用枚数</div>
      <div>Number of use</div>
    </div>
    <div class="value">{{ count }}</div>
  </div>
</template>

<script>
export default {
  name: "FaceUsedNumber",
  props: {
    count: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  line-height: 21px;
}

.value {
  margin-top: 5px;
  font-size: 32px;
  font-weight: bold;
}
</style>
